import { render, staticRenderFns } from "./[speciality].vue?vue&type=template&id=72685096&"
import script from "./[speciality].vue?vue&type=script&setup=true&lang=ts&"
export * from "./[speciality].vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72685096')) {
      api.createRecord('72685096', component.options)
    } else {
      api.reload('72685096', component.options)
    }
    module.hot.accept("./[speciality].vue?vue&type=template&id=72685096&", function () {
      api.rerender('72685096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vrach/[speciality].vue"
export default component.exports